import type { StatusTone } from "@/components/ui/status-chip";

/** Admission status → StatusChip tone and label, shared by the IPD list and its side panel. */
export function admissionStatus(status: string): { tone: StatusTone; label: string } {
  switch (status) {
    case "admitted":     return { tone: "accent",  label: "Admitted" };
    case "discharged":   return { tone: "neutral", label: "Discharged" };
    case "lama":         return { tone: "warning", label: "LAMA" };
    case "absconded":    return { tone: "alert",   label: "Absconded" };
    case "referred_out": return { tone: "neutral", label: "Referred out" };
    case "expired":      return { tone: "neutral", label: "Deceased" };
    default:             return { tone: "neutral", label: status };
  }
}

// Some beds are already named "Bed B"; don't print "Bed Bed B"
export const bedLabel = (bed: string) => (/^bed\b/i.test(String(bed ?? "").trim()) ? bed : `Bed ${bed}`);
